<template src="./form.html"></template>

<script>
import { UpdateSite, ViewSite } from '@/api/site'

export default {
  name: 'edit-site',
  data: function () {
    return {
      model: {
        id: '',
        invid: '',
        site_name: '',
        number: null
      },
      loading: false,
      ruleValidate: {
        site_name: [{
          required: true,
          message: '研究单位不能为空',
          trigger: 'change'
        }],
        invid: [{
          required: true,
          message: '中心编号不能为空',
          trigger: 'change'
        }],
        number: [{
          type: 'number',
          message: '样本量必须是数字',
          trigger: 'blur'
        }]
      }
    }
  },
  props: ['meta'],
  methods: {
    init: function (id) {
      ViewSite(id).then(async res => {
        this.model = res
      })
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      UpdateSite(this.model).then(async res => {
        if (res.id) {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
